import { Component, Input, OnInit, ViewChild } from '@angular/core';
//import { FullCalendarComponent } from '@fullcalendar/angular';
//import dayGridPlugin from '@fullcalendar/daygrid';
//import { EventInput } from '@fullcalendar/core';
//import timeGrigPlugin from '@fullcalendar/timegrid';
//import listPlugin from '@fullcalendar/list';
//import bootstrapPlugin from '@fullcalendar/bootstrap';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import interactionPlugin from '@fullcalendar/interaction'; // for dateClick
import { AddActivityModalComponent } from './add-activity-modal/add-activity-modal.component';
import { RequirementService } from 'src/app/services/requirement.service';
@Component({
    selector: 'app-calendar-view',
    templateUrl: './calendar-view.component.html',
    styleUrls: ['./calendar-view.component.scss'],
    standalone: false
})
export class CalendarViewComponent implements OnInit {
	//@ViewChild('calendar', { static: true }) calendarComponent: FullCalendarComponent; // the #calendar in the template
	@Input() reqIdCaView: number;
	@Input() idUrlCaView: number;

	calendarVisible = true;
	//calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin, listPlugin, bootstrapPlugin];
	calendarWeekends = true;
	spLocal = 'es';
	theme = 'bootstrap';
	//calendarEvents: EventInput[] = [];
	constructor(
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

	ngOnInit() {
		this.loadAlerts();
	}
	toggleVisible() {
		this.calendarVisible = !this.calendarVisible;
	}

	toggleWeekends() {
		this.calendarWeekends = !this.calendarWeekends;
	}

	gotoPast() {
		//let calendarApi = this.calendarComponent.getApi();
		//calendarApi.gotoDate('2000-01-01'); // call a method on the Calendar object
	}

	handleDateClick(arg) {
		
		const modalRef = this.modalService.open(AddActivityModalComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.currentDate = arg.dateStr;
		modalRef.componentInstance.reqId = this.reqIdCaView;
		modalRef.componentInstance.idUrlAdd = this.idUrlCaView;
		modalRef.componentInstance.insertActivity.subscribe(insertActivity => {
			if (insertActivity) {
				//this.calendarEvents = [];
				this.loadAlerts();
			}
		});
		/* if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
	  this.calendarEvents = this.calendarEvents.concat({ // add new event data. must create new array
		title: 'New Event',
		start: arg.date,
		allDay: arg.allDay
	  })
	} */
	}
	// load modules list
	loadAlerts() {
		// Getting history activities alerts
		this._requirements.getAllActivitiesCalendar(this.reqIdCaView).subscribe(resp => {
			if (resp['error']) {
				throw Error('Service Error');
			} else {
				const actvHistory = resp['result'];
				this.arrangeActivities(actvHistory);
			}
		});
	}
	// Arrange activity Alerts
	arrangeActivities(activities) {
		// tslint:disable-next-line: forin
		for (let actv in activities) {
			let dateTime = activities[actv].activity_date.substring(0, 10) + 'T' + activities[actv].activity_time;
			/*this.calendarEvents = this.calendarEvents.concat({ // add new event data. must create new array
				title: activities[actv].subject,
				start: dateTime,
			});*/
		}

	}

}
